let isMobileLayoutApplied = false;

function toggleAccordion() {
  $('.accordion .accordion__header').click(function (e) {
    e.stopPropagation();

    const currentSection = $(this).closest('section');

    const panelId = $(this).attr('aria-controls');
    const panel = $('#' + panelId);
    const isOpen = panel.is(':visible');
    currentSection.find('.accordion .accordion__panel').not(panel).not('.accordion--persistant').slideUp(500);
    currentSection.find('.accordion .accordion__header').not($(this)).not('.accordion--persistant').removeClass('active').attr('aria-expanded', 'false');


    $(this).toggleClass('active');
    panel.slideToggle(500);
    $(this).attr('aria-expanded', !isOpen);
    panel.attr('aria-hidden', isOpen);
  });
}

function moveDivsToMobileLayout() {
  if (!isMobileLayoutApplied) {
    $('.accordion-mobile__header').each(function () {
      const panelId = $(this).attr('aria-controls');
      const panelDiv = $('#' + panelId).detach();
      $(this).after(panelDiv);
    });
    isMobileLayoutApplied = true;
  }
}

function revertDivsToDesktopLayout() {
  if (isMobileLayoutApplied) {
    $('.accordion-mobile__header').each(function () {
      const panelId = $(this).attr('aria-controls');
      const panelDiv = $(this).next('.accordion-mobile__panel').detach();
      $('#' + panelId.replace('panel', '')).append(panelDiv);
      $('#' + panelId).show().attr('aria-hidden', 'false');
    });
    isMobileLayoutApplied = false;
  }
}

function toggleAccordionMobile() {
  const breakpoint = 992;

  function isMobile() {
    return $(window).width() <= breakpoint;
  }

  function setupAccordion() {
    if (isMobile()) {
      moveDivsToMobileLayout();

      $('.accordion-mobile .accordion-mobile__header').off('click').on('click', function (e) {
        e.preventDefault();

        const panelId = $(this).attr('aria-controls');
        const panel = $('#' + panelId);
        const isOpen = panel.is(':visible');

        if (!isOpen) {
          $('.accordion-mobile .accordion-mobile__panel').not(panel).slideUp(500);
          $('.accordion-mobile .accordion-mobile__header').not($(this)).removeClass('active').attr('aria-expanded', 'false');

          panel.slideDown(500);
          $(this).addClass('active').attr('aria-expanded', 'true');
          panel.attr('aria-hidden', 'false');
        } else {

          panel.slideUp(500);
          $(this).removeClass('active').attr('aria-expanded', 'false');
          panel.attr('aria-hidden', 'true');
        }
      });

      $('.accordion-mobile .accordion-mobile__panel').hide();
      $('.accordion-mobile .accordion-mobile__header').removeClass('active').attr('aria-expanded', 'false');
    } else {

      revertDivsToDesktopLayout();

      $('.accordion-mobile .accordion-mobile__header').click(function () {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
      });

      $('.accordion-mobile .accordion-mobile__panel').show().attr('aria-hidden', 'false');
      $('.accordion-mobile .accordion-mobile__header').attr('aria-expanded', 'false');
    }
  }

  $(function () {
    setupAccordion();
  });
}

export { toggleAccordion, toggleAccordionMobile };
